<template>
  <div class="header">
    <div class="title-overlay"></div>
    <div class="header-container">
      <div class="app-name">
        <router-link to="/" style="margin-top: -20px">
          <img src="@/assets/logo.png" alt="西安伟思特声学logo" style="
                                width: 70px;
                                height: 50px;
                                margin: 5px 5px -5px 0;
                                -webkit-user-drag: none;
                                -khtml-user-drag: none;
                                -moz-user-drag: none;
                                user-drag: none;
                                -webkit-user-select: none;
                                -moz-user-select: none;
                                user-select: none;
                                outline: none;
                            "/>
          <img src="@/assets/logo-2.png" alt="西安伟思特声学" style="
                                height: 50px;
                                margin: 5px 5px -5px 0;
                                -webkit-user-drag: none;
                                -khtml-user-drag: none;
                                -moz-user-drag: none;
                                user-drag: none;
                                -webkit-user-select: none;
                                -moz-user-select: none;
                                user-select: none;
                                outline: none;
                            "/>
        </router-link>
      </div>
      <div class="header-rout">
        <div class="container d-flex justify-content-between align-items-center">
          <el-menu mode="horizontal" router class="transparent-menu">
            <el-menu-item index="/"><strong>首页</strong></el-menu-item>
            <el-menu-item index="/"><strong>公司服务</strong></el-menu-item>
            <el-menu-item index="/customerCases"><strong>客户案例</strong></el-menu-item>
            <el-menu-item index="/news"><strong>新闻资讯</strong></el-menu-item>
            <el-menu-item index="/about"><strong>关于我们</strong></el-menu-item>
            <el-menu-item index="/contact"><strong>联系我们</strong></el-menu-item>
            <el-menu-item index="/faq"><strong>常见问题解答</strong></el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {};
  },
  created() {

  },
  methods: {}
};
</script>
<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 90px;
  background: white;
  display: flex;
  justify-content: center;
  border-bottom: #eeeeee solid 2px;
  z-index: 1000;
}

.header-container {
  width: 1000px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 999;
}

.title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20%;
  background: linear-gradient(rgb(255, 255, 255), rgb(199, 198, 198));
  z-index: 998;
  border-radius: 4px;
}

.app-name a {
  position: fixed;
  top: 35px;
  left: 50px;
  //right: 10px;
  //display: flex;
  color: #409EFF;
  font-size: 24px;
  text-decoration: none;
}

.transparent-menu {
  background-color: transparent;
  border-bottom: none; /* 移除底部边框 */
  color: #ffffff;
}

.transparent-menu .el-menu-item:hover {
  background-color: rgb(210, 247, 252, 0.8) !important;
  //background-color: rgb(179, 206, 215) !important;
}

</style>